export default {"src":"/_next/static/media/email-icon.cd96e8f5.svg","height":512,"width":512};